<template>
  <el-dialog
      :visible.sync="visible"
      title="选择发货记录"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="95%"
      :append-to-body="true"
  >
    <el-form ref="form" :model="dataForm" label-width="100px" :inline="true" class="query-form">
      <el-form-item prop="orderCode" label="外销合同号：">
        <order-drop v-model="dataForm.orderCode"></order-drop>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="reload">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" size="mini" @click="submitSel">确定选择</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" :selection="true" api-version="v2" url="/trade/factorystorelog/query/for/outlet"
                :auto-load="false"
                :query-form="dataForm" :before-table-binding="beforeTableBinding" :height="500"
                :summaries-column="['sendCount']">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true"
      ></el-table-column>
      <el-table-column
          prop="senderName"
          label="发货方"
          header-align="center"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="160"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column label="货物信息" min-width="180" :show-overflow-tooltip="true">
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column
          prop="price"
          label="发货单价"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="发货数"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="operateTime"
          label="发货时间"
          header-align="center"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          prop="createDate"
          label="制单时间"
          header-align="center"
          align="center"
          width="160"
      >
      </el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import ProductRowCard from '@/components/ProductRowCard.vue'
/**
 * 出口箱单选择弹窗
 */
export default {
  name: 'SelStoreLogForOutletDialog',
  mixins: [SweetTable],
  components: {
    ProductRowCard,
  },
  data () {
    return {
      dataForm: {
        receiverName:'',
        filterIds:''
      },
      visible: false,
    }
  },
  methods: {
    init (receiverName,filterIds) {
      this.dataForm.receiverName=receiverName
      this.dataForm.filterIds=filterIds.join(',')
      this.visible = true
      this.$nextTick(()=>{
        this.$refs.table.clearSelection()
        this.$refs.table.reload()
      })
    },
    beforeTableBinding (dataList) {

    },
    submitSel(){
      this.$emit('selected',this.$refs.table.dataListSelections)
      this.visible=false
    }
  }
}
</script>

<style scoped>

</style>
